var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:"myAudio"},[_c('source',{attrs:{"src":"/beep.mp3","type":"audio/mpeg"}}),_vm._v(" Your browser does not support the audio element. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }